"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toVideoSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var slice_1 = require("./slice");
var toVideoSlice = function (data, logger) {
    var video = logger.required(field_groups_1.toVideo(data.primary, logger));
    if (!video) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Video)), { video: video }));
};
exports.toVideoSlice = toVideoSlice;
//# sourceMappingURL=video-slice.js.map